import { ConfigurationCashback } from "../modules"

export const ConfigurationCashbackPage = () => {
  return (
    <ConfigurationCashback />
  )
}
